// @ts-check
import React from 'react';

import CircularProgressText from '@liquidweb-dev/undercurrent/CircularProgressText';
import Stack from '@liquidweb-dev/undercurrent/Stack';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

/** @param {import('@liquidweb-dev/undercurrent/Stack').StackProps} props */
const SuspenseFallback = ({ children, sx, ...rest }) => (
	<Stack
		sx={combineSx(
			{
				justifyContent: 'center',
				alignItems: 'center',
				flexGrow: 1,
			},
			sx,
		)}
		{...rest}
	>
		<CircularProgressText />

		{children}
	</Stack>
);

export default SuspenseFallback;
